// The bennows UI kit and the web app's shared layers (ADR-033: the console uses
// the same kit, tokens and patterns; the files stay in apps/web, one copy only).
// Same order as apps/web: kit tokens, base, components, library CSS, bridge.
import '../../web/src/styles/tokens.css';
import '../../web/src/styles/base.css';
import '../../web/src/styles/components.css';
import '@bennows/boows-react/style.css';
import '../../web/src/styles/boows-bridge.css';
import '../../web/src/styles/project.css';
import '../../web/src/styles/project-shell.css';
import '../../web/src/styles/project-page-header.css';
import '../../web/src/styles/project-app-brand.css';
import '../../web/src/styles/project-auth.css';
import '../../web/src/styles/project-tabs.css';
import '../../web/src/styles/project-charts.css';
import './styles/console.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { initI18n } from './i18n';

initI18n();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
